import React from 'react';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

import '../css/about.css';

const About = () => (
  <div className="about-section mt-1">
   <HelmetProvider>
    <Helmet>
    <title>Hakkımızda | Boduroğlu Otomotiv</title>
    <meta name="description" content="Boduroğlu Otomotiv, Dudullu Kadosan’da güvenilir oto servis hizmeti sunar. Uzman kadrosuyla motor, kaporta ve elektronik onarımlar." />
    <meta name="keywords" content="boduroğlu otomotiv, hakkımızda, dudullu oto servis, kadosan araç tamiri, kaporta boya, motor tamiri, güvenilir oto servis" />
    <meta property="og:title" content="Hakkımızda | Boduroğlu Otomotiv" />
  <meta property="og:description" content="Profesyonel oto servis, motor ve kaporta hizmetleri." />
  <meta property="og:image" content="https://bodurogluoto.com/logo.png" />
  <meta property="og:url" content="https://bodurogluoto.com/hakkimizda" />   
   </Helmet>
  </HelmetProvider>
    <div className=" mt-5 p-4 rounded shadow">
      <h2 className="display-4 text-center text-white">Hakkımızda</h2>
      <div className="about-content mt-4 text-white">
        <p>
          Boduroğlu Otomotiv olarak, İstanbul'un önemli sanayi merkezlerinden biri olan Dudullu OSB, Kadosan Oto Sanayi Sitesi'nde araç sahiplerine kapsamlı ve güvenilir oto servis hizmetleri sunmaktan gurur duyuyoruz. Yılların getirdiği tecrübe ve alanında uzman ekibimizle, aracınızın her türlü bakım ve onarım ihtiyacına profesyonel çözümler üretiyoruz.
        </p>
        <p>
          Önceliğimiz her zaman müşteri memnuniyeti ve güven olmuştur. Aracınızın bizim için değerli olduğunu biliyor, bu yüzden her işlemi titizlikle ve orijinal veya eşdeğer kalitede yedek parçalar kullanarak gerçekleştiriyoruz. Şeffaf hizmet anlayışımızla, yapılan işlemler hakkında sizi detaylıca bilgilendiriyor, onayınız olmadan hiçbir işlem yapmıyoruz.
        </p>
        <p>
          Özellikle Renault, Bmw, Mercedes, Ford, Fiat, Seat, Peugeot, Nissan, Citroën, Hyundai, Kia, Opel, Audi, Skoda ve Volkswagen markalarında derinlemesine bilgi ve deneyime sahibiz. Teknolojiyi yakından takip ederek, modern arıza tespit cihazlarımız ve ekipmanlarımızla aracınızdaki sorunları hızlı ve doğru bir şekilde teşhis ediyoruz.
        </p>
        <p>
          Motor ve mekanik aksamdan periyodik bakımlara, elektronik arızalardan kaporta ve boya işlemlerine kadar geniş bir yelpazede hizmet sunan Boduroğlu Otomotiv, aracınızı güvenle emanet edebileceğiniz adresinizdir. Sizleri de Kadosan'daki servisimize bekleriz.
        </p>
      </div>
    </div>
  </div>
);

export default About;
